<template>
  <!-- 员工工资添加 -->
  <div>
    <dialogModel
      title="提交一人"
      width="1200px"
      :visible.sync="Visible"
      @handleClose="handleClose"
      @handleOk="handleConfirm"
    >
      <div class="main-body">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="148px"
          class="demo-ruleForm"
        >
          <div class="section-row">
            <div class="section-block section-left">
              <div class="section-title">企业信息</div>
              <el-form-item label="企业名称：" prop="Purchaser" :required="true">
                <el-select
                  v-model="ruleForm.Purchaser"
                  @change="handelChange"
                  placeholder="请选择企业名称"
                  value-key="companyName"
                >
                  <el-option
                    v-for="item in options1"
                    :key="item.companyName"
                    :label="item.companyName"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="统一社会信用代码："
                prop="PurchaserCode"
                :required="true"
              >
                <div class="readonly-box">{{ ruleForm.PurchaserCode }}</div>
              </el-form-item>

              <el-form-item
                label="法定代表人(负责人)："
                prop="PurchaserName"
                :required="true"
              >
                <div class="readonly-box">{{ ruleForm.PurchaserName }}</div>
              </el-form-item>

              <el-form-item
                label="企业类型："
                prop="customerCompanyType"
                :required="true"
              >
                <el-radio-group
                  v-model="ruleForm.customerCompanyType"
                  :disabled="!EnterpriseIsItOptional"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('customerCompanyType')"
                >
                  <el-radio
                    v-for="item in Arr1"
                    :key="'et-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="纳税类型："
                prop="PayTaxesType"
                :required="true"
              >
                <el-radio-group
                  v-model="ruleForm.PayTaxesType"
                  :disabled="!PayTaxesIsItOptional"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('PayTaxesType')"
                >
                  <el-radio
                    v-for="item in Arr"
                    :key="'pt-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>

            <div class="section-block section-right">
              <div class="section-title">员工信息</div>

              <el-form-item
                label="员工姓名："
                prop="EmployeeName"
                :required="true"
              >
                <el-input
                  v-model="ruleForm.EmployeeName"
                  placeholder="请输入员工姓名"
                  maxlength="30"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="员工身份证号："
                prop="EmployeeNumber"
                :required="true"
              >
                <el-input
                  v-model="ruleForm.EmployeeNumber"
                  placeholder="请输入员工身份证号"
                  maxlength="30"
                ></el-input>
              </el-form-item>

              <el-form-item label="年月：" prop="Year" :required="true">
                <div class="YearMonth">
                  <el-date-picker
                    v-model="ruleForm.Year"
                    :clearable="false"
                    type="year"
                    placeholder="请选择申报年份"
                    value-format="yyyy"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>

              <el-form-item label="年月：" prop="Month" :required="true">
                <div class="YearMonth">
                  <el-date-picker
                    v-model="ruleForm.Month"
                    :clearable="false"
                    type="month"
                    placeholder="选择月"
                    value-format="MM"
                    format="MM"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>

              <el-form-item label="工资(元)：" prop="Salary" :required="true">
                <el-input
                  v-model="ruleForm.Salary"
                  placeholder="请输入变更后工资（元）"
                  maxlength="30"
                  @input="onSalaryInput"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </dialogModel>
  </div>
</template>

<script>
import * as API from "@/assets/api/Agency/Enterprise.js";
export default {
  props: {
    Visible: {},
    InChange: {},
    options1: {}, //平台企业客户
    enterprise: {}, //平台企业信息
  },
  components: {},
  data() {
    return {
      Arr: [
        { id: 0, name: "小规模纳税人" },
        { id: 1, name: "一般纳税人" },
      ], //纳税类型选项
      Arr1: [
        { id: 0, name: "有限公司" },
        { id: 2, name: "子公司" },
        { id: 3, name: "分公司" },
        { id: 1, name: "个体户" },
        { id: 4, name: "其它" },
      ], //企业类型选项

      ruleForm: {
        Purchaser: "", //购买方
        PurchaserName: "", //法人
        PurchaserId: "", //购买方
        PurchaserCode: "", //购买方统一代码
        PurchaserPhone: "", //购买方联系电话
        customerCompanyType: null, //购买方公司类型
        PurchaseBankName: "", //购买方开户银行名称
        PurchaseAccount: "", //购买方开户账号
        PurchaseAddress: "", //购买方地址
        PayTaxesType: null, //纳税人类型

        EmployeeName: "", //员工姓名
        EmployeeNumber: "", //员工身份证号
        Year: "", //年
        Month: "", //月
        Salary: "", //工资
      },
      rules: {
        // 规则未完善
        Purchaser: [
          {
            required: true,
            message: "请选择企业",
            trigger: ["blur", "change"],
          },
        ],
        PurchaserCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        PurchaserName: [
          {
            required: true,
            message: "法人姓名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        customerCompanyType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: ["blur", "change"],
          },
        ],
        PayTaxesType: [
          {
            required: true,
            message: "请选择纳税类型",
            trigger: ["blur", "change"],
          },
        ],

        EmployeeName: [
          {
            required: true,
            message: "请输入员工姓名",
            trigger: ["blur", "change"],
          },
        ],
        EmployeeNumber: [
          {
            required: true,
            message: "请输入员工身份证号",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的身份证号码",
            trigger: ["blur", "change"],
            pattern:
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          },
        ],

        Year: [
          { required: true, message: "选择年份", trigger: ["blur", "change"] },
        ],
        Month: [
          { required: true, message: "选择月份", trigger: ["blur", "change"] },
        ],
        Salary: [
          {
            required: true,
            message: "请输入变更后的工资",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              const raw = String(value == null ? "" : value).trim();
              if (!raw) {
                callback(new Error("请输入变更后的工资"));
                return;
              }
              if (!/^[0-9]+(\.[0-9]{1,2})?$/.test(raw)) {
                callback(new Error("请输入数字（可保留两位小数）"));
                return;
              }
              const num = Number(raw);
              if (Number.isNaN(num) || num < 0) {
                callback(new Error("请输入正确的工资金额"));
                return;
              }
              if (num > 1000000) {
                callback(new Error("工资金额不能超过100万元"));
                return;
              }
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
      },
      options: [{ label: "xx", value: "1" }], //公司选择
      optionsYear: [{ label: "xx", value: "1" }], //年选择
      optionsMonth: [{ label: "xx", value: "1" }], //月选择
      EnterpriseIsItOptional: true, //企业类型是否可选
      PayTaxesIsItOptional: true, //纳税类型是否可选
    };
  },
  watch: {
    Visible: {
      handler(newSs, old) {
        if (newSs == false) {
          this.ruleForm = {
            Purchaser: "", //购买方
            PurchaserName: "", //法人
            PurchaserId: "", //购买方
            PurchaserCode: "", //购买方统一代码
            PurchaserPhone: "", //购买方联系电话
            customerCompanyType: null, //购买方公司类型
            PurchaseBankName: "", //购买方开户银行名称
            PurchaseAccount: "", //购买方开户账号
            PurchaseAddress: "", //购买方地址
            PayTaxesType: null, //纳税人类型

            EmployeeName: "", //员工姓名
            EmployeeNumber: "", //员工身份证号
            Year: "", //年
            Month: "", //月
            Salary: "", //工资
          };
          this.EnterpriseIsItOptional = true;
          this.PayTaxesIsItOptional = true;
          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 300);
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  methods: {
    /** 工资：最多 100 万，最多两位小数 */
    onSalaryInput(val) {
      let next = String(val == null ? "" : val).replace(/[^\d.]/g, "");
      const parts = next.split(".");
      if (parts.length > 2) {
        next = parts[0] + "." + parts.slice(1).join("");
      }
      const segs = next.split(".");
      if (segs[1] != null && segs[1].length > 2) {
        next = segs[0] + "." + segs[1].slice(0, 2);
      }
      if (next !== "" && next !== ".") {
        const num = Number(next);
        if (Number.isFinite(num) && num > 1000000) {
          next = "1000000";
        }
      }
      this.ruleForm.Salary = next;
    },
    //选择购买方
    handelChange(val) {
      this.EnterpriseIsItOptional= true //企业类型是否可选
      this.PayTaxesIsItOptional =  true //纳税类型是否可选
      console.log(val, this.ruleForm.Purchaser, "val");
      this.ruleForm.Purchaser = val.companyName;
      this.ruleForm.PurchaserCode = val.customerCreditCode;
      this.ruleForm.PurchaserPhone = val.phone;
      this.ruleForm.PurchaserId = val.id;
      this.ruleForm.PurchaserName = val.legalPerson;
      this.ruleForm.customerCompanyType = val.customerCompanyType;
      this.ruleForm.PurchaseBankName = val.customerBankName;
      this.ruleForm.PurchaseAccount = val.customerBankAccount;
      this.ruleForm.PurchaseAddress = val.customerCompanyAddress;
      this.ruleForm.PayTaxesType = val.customerTaxType;
      this.$refs.ruleForm.clearValidate();
      if (val.customerCompanyType !== null && val.customerCompanyType !== "") {
        // 自动选中企业类型，不可在修改
        this.EnterpriseIsItOptional = false;
      }
      if (val.customerTaxType !== null && val.customerTaxType !== "") {
        // 自动选中纳税类型，不可在修改
        this.PayTaxesIsItOptional = false;
      }
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseUp");
    },
    // 确认
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          var data = {
            data: {
              // buyCompanyId: 0,//
              buyCompanyName: this.enterprise.companyName, //平台企业名称
              buyCreditCode: this.enterprise.customerCreditCode, //平台社会信用代码
              buyCompanyPhone: this.enterprise.phone, //平台公司电话
              orderCompanyName: this.ruleForm.Purchaser, //订单企业名称
              orderCreditCode: this.ruleForm.PurchaserCode, //订单公司信用代码
              orderCompanyType: this.ruleForm.customerCompanyType, //订单企业类型
              orderTaxType: this.ruleForm.PayTaxesType, //订单纳税类型
              orderLegalPersonName: this.ruleForm.PurchaserName, //订单法人名称
              modelList: [
                {
                  empName: this.ruleForm.EmployeeName, //员工姓名
                  empIdCard: this.ruleForm.EmployeeNumber, //员工身份证号
                  wagesYear: this.ruleForm.Year, //工资年度
                  wagesMonth: this.ruleForm.Month, //月工资
                  wages: this.ruleForm.Salary, //工资
                  remark: "工资", //备注
                  wagesTime: this.ruleForm.Year + "-" + this.ruleForm.Month, //工资时间
                },
              ],
            },
          };
          API.addEmpWagesInfo(data).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.$emit("handleConfirm");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../bookkeeping-form-dialog.less";
</style>
